import * as React from 'react';
import { Component } from 'react';
import styles from '../../styles/flyouts/meetings/MeetingsFlyout.scss';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import CloseBigIcon from '../../assets/images/close-big-15x15.svg';
import classNames from 'classnames';
import * as _ from 'lodash';
import autobind from 'autobind-decorator';
import { __, setTableParams } from '../../core/utils';
import EditMeetingToolbarForm from '../../forms/meetings/EditMeetingToolbarForm';
import Properties from './Properties';
import {
  listAllMeetings,
  updateMeetingToolbar,
} from '../../redux/actions/table/all_meetings';
import { setNotification } from '../../redux/actions/general/notification';
import Tooltip from '../../components/Tooltip';
import SendIcon from '../../assets/images/send-16x16.svg';
import PrintIcon from '../../assets/images/print-16x16.svg';
import Archive from './Archive';
import MeetingFollowUpIcon from '../../assets/images/meeting-follow-up-16x16.svg';
import ArrowDownMiddleIcon from '../../assets/images/arrow-down-middle-15x15.svg';
import { Element, ScrollLink, scrollSpy } from 'react-scroll';

const mapDispatchToProps = (dispatch) => {
  return {
    actions: {
      setTableParams: (params) =>
        dispatch({
          type: 'table.all_meetings/SET_TABLE_PARAMS',
          params,
        }),
    },
  };
};

@connect(
  (state) => ({
    forceMeetingUpdate: _.get(state.table, 'all_meetings.forceMeetingUpdate'),
    user_id: state.auth.id,
  }),
  mapDispatchToProps
)
@withRouter
class MeetingsFlyout extends Component {
  constructor(props) {
    super(props);

    this.state = {
      collapsed_tabs: [], //fix for scrollSpy not working on init
      highlighted_tab: null,
      history_expanded: false,
    };

    this.highlight_timeout = null;

    this.tabs = ['properties', 'archive'];

    this.tab_refs = [];
  }

  componentDidMount() {
    scrollSpy.update();

    if (this.props.tab_opened) {
      setTimeout(() => {
        this.tab_refs[this.props.tab_opened] &&
          this.tab_refs[this.props.tab_opened].click();

        setTableParams('all_meetings', {
          tab: undefined,
        });
      }, 500);
    }
  }

  @autobind
  _toggleCollapseTab(tab) {
    this.setState({
      collapsed_tabs: _.xor(this.state.collapsed_tabs, [tab]),
    });
  }

  _highlightSection(section) {
    this.setState({ highlighted_tab: section }, () => {
      if (this.highlight_timeout) clearTimeout(this.highlight_timeout);

      this.highlight_timeout = setTimeout(() => {
        this.setState({ highlighted_tab: null });
      }, 200);
    });
  }

  @autobind
  _toggleCollapseTabs() {
    if (_.size(this.state.collapsed_tabs) == _.size(this.tabs)) {
      this.setState({
        collapsed_tabs: [],
      });
    } else {
      this.setState({
        collapsed_tabs: this.tabs,
      });
    }

    this.refs.scroll.scrollTop = 0;
  }

  @autobind
  _handleSubmit(formData) {
    updateMeetingToolbar(formData.id, {
      ..._.omit(formData, ['id']),
    }).then(() => {
      this.props.match.params.stage &&
        listAllMeetings(
          this.props.match.params.stage,
          this.props.match.params.status
        );

      this.props.readAction(formData.id);

      setNotification(__('tasks.properties.saved'));
    });
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    if (!prevProps.forceMeetingUpdate && this.props.forceMeetingUpdate) {
      setTableParams('all_meetings', {
        forceMeetingUpdate: undefined,
      });

      this.props.readAction(this.props.data.id);
    }
  }

  render() {
    const { data, readAction, user_id } = this.props;
    const is_administrator = _.isObject(
      _.find(data.administrators, ['id', user_id])
    );

    const { collapsed_tabs, highlighted_tab } = this.state;

    const TabLink = ScrollLink((props) => (
      <span
        ref={(ref) => (this.tab_refs[props.target] = ref)}
        onClick={(e) => {
          this.setState({
            collapsed_tabs: _.reject(
              collapsed_tabs,
              (section) => section == props.target
            ),
          });

          props.target == 'history' && this._lazyLoadTaskHistory();

          this._highlightSection(props.target);

          props.onClick(e);
        }}
        className={props.className}
      >
        {props.children}
      </span>
    ));

    const Tab = (props) => (
      <TabLink
        target={props.target}
        activeClass={styles.active}
        to={props.target}
        spy={true}
        smooth={true}
        duration={500}
        container={this.refs.scroll}
      >
        {props.children}
      </TabLink>
    );

    return (
      <div className={styles.preview}>
        <div className={styles.header}>
          <div className={styles.title}>
            <span>
              <strong>{'M-' + _.padStart(data.identifier, 4, '0')}:</strong>
              {_.get(
                data.title,
                _.findKey(
                  _.get(data, 'project_languages'),
                  (primary) => primary == 1
                )
              )}
            </span>
            <CloseBigIcon
              onClick={() =>
                setTimeout(() => {
                  this.props.actions.setTableParams({
                    clicked_row: undefined,
                  });
                }, 100)
              }
            />
          </div>
          <div className={styles.actions}>
            {data.is_editor && (
              <div className={styles.actionWrapper}>
                <Tooltip text={__('meetings.tooltip.icon.create-follow-up')}>
                  <MeetingFollowUpIcon
                    onClick={(e) => {
                      e.stopPropagation();

                      setTableParams('all_meetings', {
                        create_followup_meeting_wizard: data.id,
                      });
                    }}
                  />
                </Tooltip>
              </div>
            )}
            {is_administrator && (
              <div className={styles.actionWrapper}>
                <Tooltip text={__('meetings.tooltip.icon.send-meeting-report')}>
                  <SendIcon
                    onClick={(e) => {
                      e.stopPropagation();

                      setTableParams('all_meetings', {
                        send_meeting_report_wizard: true,
                        meeting_id: data.id,
                        send: true,
                      });
                    }}
                  />
                </Tooltip>
              </div>
            )}
            <div className={styles.actionWrapper}>
              <Tooltip text={__('meetings.tooltip.icon.print-meeting-report')}>
                <PrintIcon
                  onClick={(e) => {
                    e.stopPropagation();

                    setTableParams('all_meetings', {
                      print_meeting_report_wizard: true,
                      meeting_id: data.id,
                      meeting_status: data.status,
                      send: false,
                    });
                  }}
                />
              </Tooltip>
            </div>
          </div>
        </div>
        <div className={styles.toolbar}>
          <EditMeetingToolbarForm
            data={data}
            onSubmit={this._handleSubmit}
            initialValues={{
              ..._.pick(data, ['id', 'date', 'status']),
              visibility: _.toString(data.visibility),
            }}
          />
        </div>

        <div className={styles.tabsWrapper}>
          <ArrowDownMiddleIcon
            className={classNames(
              styles.collapseAll,
              _.size(collapsed_tabs) == _.size(this.tabs) && styles.collapsed
            )}
            onClick={this._toggleCollapseTabs}
          />
          <div className={styles.tabs}>
            <Tab target='properties'>{__('meetings.flyout.properties')}</Tab>
            <Tab target='archive'>
              {__('meetings.flyout.archive')}{' '}
              {(!_.isEmpty(data.agenda_reports) ||
                !_.isEmpty(data.closed_reports)) &&
                ' (' +
                  (_.size(data.agenda_reports) + _.size(data.closed_reports)) +
                  ')'}
            </Tab>
          </div>
        </div>

        <div className={styles.content} ref='scroll'>
          <Element
            name='properties'
            className={classNames(
              styles.section,
              highlighted_tab == 'properties' && styles.highlighted
            )}
          >
            <div
              className={styles.title}
              onClick={() => this._toggleCollapseTab('properties')}
            >
              <ArrowDownMiddleIcon
                className={classNames(
                  styles.collapse,
                  _.includes(collapsed_tabs, 'properties') && styles.collapsed
                )}
              />
              {__('meeting.flyout.properties')}
            </div>
            <Properties
              collapsed={_.includes(collapsed_tabs, 'properties')}
              data={data}
              readAction={readAction}
            />
          </Element>

          <Element
            name='archive'
            className={classNames(
              styles.section,
              highlighted_tab == 'archive' && styles.highlighted
            )}
          >
            <div
              className={styles.title}
              onClick={() => this._toggleCollapseTab('archive')}
            >
              <ArrowDownMiddleIcon
                className={classNames(
                  styles.collapse,
                  _.includes(collapsed_tabs, 'archive') && styles.collapsed
                )}
              />
              {__('meeting.flyout.archive')}
            </div>
            <Archive
              collapsed={_.includes(collapsed_tabs, 'archive')}
              data={data}
              readAction={readAction}
            />
          </Element>
        </div>
      </div>
    );
  }
}

export default MeetingsFlyout;
